import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page"
  }, [_c("template", {
    slot: "header"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "视频名称"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "视频名称"
    },
    model: {
      value: _vm.searchForm.videoName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "videoName", $$v);
      },
      expression: "searchForm.videoName"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.search
    }
  }, [_c("i", {
    staticClass: "fa fa-search"
  }), _vm._v(" 查询")]), _vm.buttonPerms(_vm.$route.path + ":add") ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.add
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加")]) : _vm._e()], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.buttonPerms(_vm.$route.path + ":preview") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.preview(scope.row.id);
            }
          }
        }, [_vm._v("预览")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":edit") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row);
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":del") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.del(scope.row.id);
            }
          }
        }, [_vm._v("删除")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "videoName",
      label: "视频名称",
      "min-width": "150",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "ezvizSerial",
      label: "设备号",
      width: "180",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "ezvizChannel",
      label: "通道号",
      width: "80",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "videoCategory",
      label: "视频类别",
      sortable: "custom",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.videoCategory == "Ezviz" ? _c("div", [_vm._v("萤石云")]) : _vm._e(), scope.row.videoCategory == "China_Ezviz" ? _c("div", [_vm._v("国渔平台")]) : _vm._e(), scope.row.videoCategory == "Uniview" ? _c("div", [_vm._v("宇视云")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "ezvizQuality",
      label: "清晰度",
      sortable: "custom",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.videoCategory == "China_Ezviz" ? _c("div", [_vm._v("--")]) : _c("div", [scope.row.ezvizQuality == 1 ? _c("div", [_vm._v(" 高清（主码流）")]) : _vm._e(), scope.row.ezvizQuality == 2 ? _c("div", [_vm._v("流畅（子码流）")]) : _vm._e()])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "ezvizProtocol",
      label: "视频协议",
      sortable: "custom",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.videoCategory == "China_Ezviz" ? _c("div", [_vm._v("--")]) : _c("div", [scope.row.ezvizProtocol == 1 ? _c("div", [_vm._v("ezopen")]) : _vm._e(), scope.row.ezvizProtocol == 2 ? _c("div", [_vm._v("hls")]) : _vm._e(), scope.row.ezvizProtocol == 3 ? _c("div", [_vm._v("rtmp")]) : _vm._e(), scope.row.ezvizProtocol == 4 ? _c("div", [_vm._v("flv")]) : _vm._e()])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "labName",
      label: "所属企业",
      sortable: "custom",
      "min-width": "150",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "areaName",
      label: "所属养殖区域",
      sortable: "custom",
      "min-width": "150",
      "show-overflow-tooltip": ""
    }
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.searchForm.page,
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  }), _c("el-dialog", {
    attrs: {
      visible: _vm.editDialogShow,
      title: _vm.editDialogTitle,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialogShow = $event;
      },
      close: function close($event) {
        return _vm.initFormData(_vm.emptyFormData);
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "所属企业",
      "label-width": _vm.formLabelWidth,
      prop: "labId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择所属企业"
    },
    model: {
      value: _vm.formData.labName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "labName", $$v);
      },
      expression: "formData.labName"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      disabled: _vm.isBusiness,
      size: "mini",
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.lab_show = !_vm.lab_show;
      }
    }
  }, [_vm._v("选择")])], 1)])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "所属养殖区域",
      "label-width": _vm.formLabelWidth,
      prop: "areaId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择所属养殖区域"
    },
    model: {
      value: _vm.formData.areaName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "areaName", $$v);
      },
      expression: "formData.areaName"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.area_show = !_vm.area_show;
      }
    }
  }, [_vm._v("选择")])], 1)])], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "名称",
      "label-width": _vm.formLabelWidth,
      prop: "videoName"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入视频名称"
    },
    model: {
      value: _vm.formData.videoName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "videoName", $$v);
      },
      expression: "formData.videoName"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "\u6392\u5E8F\u53F7",
      "label-width": _vm.formLabelWidth,
      prop: "sort"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入排序号"
    },
    model: {
      value: _vm.formData.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "sort", $$v);
      },
      expression: "formData.sort"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "\u8BBE\u5907\u5E8F\u5217\u53F7",
      "label-width": _vm.formLabelWidth,
      prop: "ezvizSerial"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入设备序列号"
    },
    model: {
      value: _vm.formData.ezvizSerial,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "ezvizSerial", $$v);
      },
      expression: "formData.ezvizSerial"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "\u8BBE\u5907\u901A\u9053\u53F7",
      "label-width": _vm.formLabelWidth,
      prop: "ezvizChannel"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入设备通道号"
    },
    model: {
      value: _vm.formData.ezvizChannel,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "ezvizChannel", $$v);
      },
      expression: "formData.ezvizChannel"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "视频类别",
      "label-width": _vm.formLabelWidth,
      prop: "videoCategory"
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "small"
    },
    model: {
      value: _vm.formData.videoCategory,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "videoCategory", $$v);
      },
      expression: "formData.videoCategory"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Ezviz"
    }
  }, [_vm._v("萤石云")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "China_Ezviz"
    }
  }, [_vm._v("国渔平台")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "NVR"
    }
  }, [_vm._v("硬盘录像机")])], 1)], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "流播放协议",
      "label-width": _vm.formLabelWidth,
      prop: "ezvizProtocol"
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "small"
    },
    model: {
      value: _vm.formData.ezvizProtocol,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "ezvizProtocol", $$v);
      },
      expression: "formData.ezvizProtocol"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: 1
    }
  }, [_vm._v("ezopen")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: 2
    }
  }, [_vm._v("hls")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: 3
    }
  }, [_vm._v("rtmp")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: 4
    }
  }, [_vm._v("flv")])], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "清晰度",
      "label-width": _vm.formLabelWidth,
      prop: "ezvizQuality"
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "small"
    },
    model: {
      value: _vm.formData.ezvizQuality,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "ezvizQuality", $$v);
      },
      expression: "formData.ezvizQuality"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: 2
    }
  }, [_vm._v("流畅（子码流）")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: 1
    }
  }, [_vm._v("高清（主码流）")])], 1)], 1)], 1)], 1), _vm.formData.videoCategory === "NVR" ? _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "NVR地址",
      "label-width": _vm.formLabelWidth,
      prop: "nvrUrl"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入NVR地址"
    },
    model: {
      value: _vm.formData.nvrUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "nvrUrl", $$v);
      },
      expression: "formData.nvrUrl"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "NVR端口",
      "label-width": _vm.formLabelWidth,
      prop: "nvrPort"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入NVR端口"
    },
    model: {
      value: _vm.formData.nvrPort,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "nvrPort", $$v);
      },
      expression: "formData.nvrPort"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "NVR帐号",
      "label-width": _vm.formLabelWidth,
      prop: "nvrAccount"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入NVR帐号"
    },
    model: {
      value: _vm.formData.nvrAccount,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "nvrAccount", $$v);
      },
      expression: "formData.nvrAccount"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "NVR密码",
      "label-width": _vm.formLabelWidth,
      prop: "nvrPassword"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入NVR密码"
    },
    model: {
      value: _vm.formData.nvrPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "nvrPassword", $$v);
      },
      expression: "formData.nvrPassword"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.formData.videoCategory === "Ezviz" ? _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "APP_KEY",
      "label-width": _vm.formLabelWidth,
      prop: "ezvizKey"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入APP_KEY"
    },
    model: {
      value: _vm.formData.ezvizKey,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "ezvizKey", $$v);
      },
      expression: "formData.ezvizKey"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "APP_Secret",
      "label-width": _vm.formLabelWidth,
      prop: "ezvizSecret"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入APP_Secret"
    },
    model: {
      value: _vm.formData.ezvizSecret,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "ezvizSecret", $$v);
      },
      expression: "formData.ezvizSecret"
    }
  })], 1)], 1)], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "备注",
      "label-width": _vm.formLabelWidth,
      prop: "remark"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      placeholder: "请输入备注"
    },
    model: {
      value: _vm.formData.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "remark", $$v);
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.closeEditDialogShow
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitFormData
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm.preview_show ? _c("camera", {
    attrs: {
      id: _vm.preview_id
    },
    on: {
      close: function close($event) {
        _vm.preview_show = false;
      }
    }
  }) : _vm._e(), _vm.lab_show ? _c("labSel", {
    on: {
      "child-lab-sel": _vm.labSel
    }
  }) : _vm._e(), _vm.area_show ? _c("areaSel", {
    attrs: {
      labId: _vm.formData.labId || ""
    },
    on: {
      "child-area-sel": _vm.areaSel
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };